import { render, staticRenderFns } from "./InputSigarus.vue?vue&type=template&id=6dab3d9e"
import script from "./InputSigarus.vue?vue&type=script&lang=js"
export * from "./InputSigarus.vue?vue&type=script&lang=js"
import style0 from "./InputSigarus.vue?vue&type=style&index=0&id=6dab3d9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports